module.exports = __webpack_public_path__ + "img/icon-fight.18b8a703.svg";